import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { SocketService } from "../../../../../../core/service/socket/socket.service";
import { LocationUpdate, StatusMapping, StoredLocation } from "../interfaces/map-tracking.interfaces";
import { StorageService } from "../../../../../../core/service/storage.service";

@Injectable({ providedIn: "root" })
export class MapTrrackingService {
  private isApiStatus = false;
  private readonly STATUS_MAPPING: StatusMapping = {
    39: 'Rechazado por establecimiento',  // Agregar este estado
    40: 'Delivery',
    41: 'Pago Rechazado',
    21: 'Proceso de pago',
    22: 'Recolectando',
    26: 'Esperando producto',
    23: 'Delivery',
    25: 'Entregando',
    24: 'Entregado'
  };
  private isSocketConnected = false;
  private readonly STORAGE_KEY = 'lastDeliveryLocation';
  private status = new BehaviorSubject<number>(40);
  private currentOrderId: number | null = null;
  private deliveryLocation = new BehaviorSubject<{ lat: number; lng: number } | null>(null);

  constructor(private socketService: SocketService, private storageService: StorageService) {
    this.loadLastLocation();
  }

  private loadLastLocation() {
    const location = this.storageService.getItem<StoredLocation>(this.STORAGE_KEY);
    if (location) {
      const thirtyMinutesAgo = Date.now() - (30 * 60 * 1000);

      if (location.timestamp > thirtyMinutesAgo) {
        this.currentOrderId = location.orderId;
        this.deliveryLocation.next({
          lat: location.lat,
          lng: location.lng
        });
        this.status.next(location.status);
      } else {
        this.storageService.removeItem(this.STORAGE_KEY);
      }
    }
  }
  isFromApi(): boolean {
    return this.isApiStatus;
  }
  private saveLocation(location: { lat: number; lng: number }, status: number) {
    if (this.currentOrderId) {
      const storedLocation: StoredLocation = {
        ...location,
        orderId: this.currentOrderId,
        status,
        timestamp: Date.now()
      };
      this.storageService.setItem(this.STORAGE_KEY, storedLocation);
    }
  }
  setStatus(status: number, isFromApi: boolean = false) {
    // Only update status from API if socket isn't connected
    if (isFromApi && this.isSocketConnected) {
      return;
    }
    this.status.next(status);
  }

  getStatus(): Observable<number> {
    return this.status.asObservable();
  }

  getStatusText(status: number): string {
    return this.STATUS_MAPPING[status] || 'Estado desconocido';
  }

  getDeliveryLocation(): Observable<{ lat: number; lng: number } | null> {
    return this.deliveryLocation.asObservable();
  }

  startTrackingOrder(orderId: number) {
    this.currentOrderId = orderId;
    this.isSocketConnected = false;

    this.socketService.on('sendLocation', (data: LocationUpdate) => {
      // console.log('Location update received:', data);
      this.isSocketConnected = true;

      if (data.orderId === this.currentOrderId?.toString()) {
        const location = {
          lat: data.latitude,
          lng: data.longitude
        };
        this.deliveryLocation.next(location);

        if (data.status) {
          this.setStatus(data.status);
          this.saveLocation(location, data.status);
        }
      }
    });

    this.socketService.emit('startTracking', { orderId: orderId }).catch(error => {
      console.error('Error al iniciar seguimiento de orden:', error);
    });
  }

  stopTrackingOrder() {
    if (this.currentOrderId) {
      this.socketService.removeAllListeners('sendLocation');
      const currentStatus = this.status.value;
      if (currentStatus === 24 || currentStatus === 41 || currentStatus === 39) {
        this.currentOrderId = null;
        this.deliveryLocation.next(null);
        this.storageService.removeItem(this.STORAGE_KEY);
      }
    }
  }

  getCurrentOrderId(): number | null {
    return this.currentOrderId;
  }

  ngOnDestroy() {
    this.stopTrackingOrder();
  }
}
